import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" fill="currentColor" {...this.props}><path d="M21 9h-9V0H9v9H0v3h9v9h3v-9h9" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/plus.inline.svg